module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "pages-home"
  }, [_c('Loader', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.loading),
      expression: "loading"
    }]
  }), (_vm.props && !_vm.loading) ? _c('div', [_c('BgVideo', {
    attrs: {
      "props": _vm.props.acf
    }
  }), _c('ContentSections', {
    attrs: {
      "props": _vm.props.acf.content
    }
  }), _c('Intro', {
    attrs: {
      "props": _vm.props.acf.intro
    }
  }), _c('TabSection', {
    attrs: {
      "props": _vm.props.acf.tab_section
    }
  }), _c('Slider', {
    attrs: {
      "props": _vm.props.acf.slider
    }
  }), _c('OfficeTour', {
    attrs: {
      "props": _vm.props.acf.office_tour
    }
  }), _c('Reviews', {
    attrs: {
      "props": _vm.props.acf.reviews
    }
  }), _c('transition', {
    attrs: {
      "name": "fade-in"
    }
  }, [_c('VideoModal', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.$store.state.showVideo),
      expression: "$store.state.showVideo"
    }],
    attrs: {
      "props": _vm.props.acf.modal_video
    }
  })], 1)], 1) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1c94a98c","hasScoped":false}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./src/pages/home/home.pug
// module id = 564
// module chunks = 1